import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {/* Brand */}
          <div>
            <h3 className="text-2xl lg:text-3xl font-black tracking-tighter mb-6">
              BORNFROMSHINE
            </h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              Redefining contemporary fashion through bold design and uncompromising quality.
            </p>
          </div>

          {/* Shop */}
          <div>
            <h4 className="text-sm font-bold tracking-wider mb-6">SHOP</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/catalog?category=outerwear" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Outerwear
                </Link>
              </li>
              <li>
                <Link to="/catalog?category=tops" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Tops
                </Link>
              </li>
              <li>
                <Link to="/catalog?category=bottoms" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Bottoms
                </Link>
              </li>
              <li>
                <Link to="/catalog?category=accessories" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Accessories
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-sm font-bold tracking-wider mb-6">SUPPORT</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Shipping
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Returns
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">
                  Size Guide
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-sm font-bold tracking-wider mb-6">NEWSLETTER</h4>
            <p className="text-sm text-gray-400 mb-4">
              Subscribe for exclusive access to new releases.
            </p>
            <div className="flex">
              <input
                type="email"
                placeholder="Email"
                className="flex-1 bg-white text-black px-4 py-3 text-sm focus:outline-none"
              />
              <button className="bg-white text-black px-6 py-3 text-sm font-bold hover:bg-gray-200 transition-colors">
                →
              </button>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">
            © 2024 BORNFROMSHINE. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-gray-500 hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-xs text-gray-500 hover:text-white transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
